import { api } from '@/api'

// 查询用电箱管理系统-工单管理列表
export function listOrder(query) {
  return api({
    headers: {
      memberId: window.localStorage.getItem('memberId'),
      Authorization: window.localStorage.getItem('Authorization'),
    },
    url: '/zouk/box/web/order/page',
    method: 'get',
    params: query,
  })
}

// 查询用电箱管理系统-工单管理详细
export function getOrder(id) {
  return api({
    headers: {
      memberId: window.localStorage.getItem('memberId'),
      Authorization: window.localStorage.getItem('Authorization'),
    },
    url: '/zouk/box/web/order/detail/' + id,
    method: 'get',
  })
}

// 新增用电箱管理系统-工单管理
export function addOrder(data) {
  return api({
    headers: {
      memberId: window.localStorage.getItem('memberId'),
      Authorization: window.localStorage.getItem('Authorization'),
    },
    url: '/zouk/box/web/order/add',
    method: 'post',
    data: data,
  })
}

// 修改用电箱管理系统-工单管理
export function updateOrder(data) {
  return api({
    headers: {
      memberId: window.localStorage.getItem('memberId'),
      Authorization: window.localStorage.getItem('Authorization'),
    },
    url: '/zouk/box/web/order/update',
    method: 'post',
    data: data,
  })
}

// 删除用电箱管理系统-工单管理
export function delOrder(id) {
  return api({
    headers: {
      memberId: window.localStorage.getItem('memberId'),
      Authorization: window.localStorage.getItem('Authorization'),
    },
    url: '/zouk/box/web/order/remove/' + id,
    method: 'post',
  })
}

// 处理用电箱管理系统-工单管理
export function handleOrder(data) {
  return api({
    headers: {
      memberId: window.localStorage.getItem('memberId'),
      Authorization: window.localStorage.getItem('Authorization'),
    },
    url: '/zouk/box/web/order/handle',
    method: 'post',
    data: data,
  })
}
